import { Grid, GridColumn as Column } from '@progress/kendo-react-grid'
import { ChunkProgressBar } from '@progress/kendo-react-progressbars'
import { NameCell } from 'components/content-pool/kendocells'
import { DashboardMenuOption } from 'components/dashboard-menu/constants'
import { RasaContext } from 'context'
import { Dataset } from 'generic/dataset'
import * as React from 'react'
import { Col, Row } from 'reactstrap'
import { getCurrentPlanMaxSources } from 'shared_server_client/types/billing_plan'
import * as Constants from './constants'
import { VideoComponent } from './onboarding-videos'
import { DEFAULT_PARTNER_IDENTIFIER } from 'shared_server_client/constants'

interface SourcesState {
  loaded: boolean
  numberOfActiveSources: number
  sourcesToDisplay: []
  video?: Constants.DashboardVideo,
  partnerIdentifier: string
}

type SourcesProps = any

export class OnboardingSourcesComponent extends React.Component<SourcesProps, SourcesState> {
    public static contextType = RasaContext;
    private progressStyles = { background: '#72cac2' }

    constructor(p: any) {
      super(p, 'communitySource')
      this.state = {
        loaded: false,
        numberOfActiveSources: 0,
        sourcesToDisplay: [],
        video: Constants.DASHBOARD_VIDEOS()[0],
        partnerIdentifier: DEFAULT_PARTNER_IDENTIFIER
      }
  }

  public componentDidMount() {
    this.context.user.init().then(({activeCommunity}) => {
      new Dataset()
        .loadCommunityDataset('communitySources', activeCommunity.communityId)
        .then((response) => {
          const sources = response[0] || []
          const activeSources = sources.filter((s) => !!s.is_active && s.source_type !== 'Manual Entry')
                                       .sort((s1, s2) => s2.last_week_total - s1.last_week_total)
          this.setState({
            numberOfActiveSources: activeSources.length,
            sourcesToDisplay: activeSources.slice(0, 5),
            partnerIdentifier: activeCommunity.billingInfo.productSubscription.account_partner_identifier,
          })
        })
    })
  }

  public render = () => {
    return (
    <div className="onboarding-chart onboarding-sources-chart">
        <Row>
            <Col sm="12">
              <VideoComponent videoWidth={12} hideContent={true} video={this.state.video}/>
            </Col>
        </Row>
        <Row className="onboarding-sources-chart-content">
            <Col sm="9">
              <Row className="title">
                {this.state.video.title}
              </Row>
              <Row className="description">
                {this.state.video.description}
              </Row>
              </Col>
            <Col sm="3">
              <Row className="links">
                <a href={this.state.video.clickUrl}>
                  <button>{this.state.video.clickTitle || this.state.video.clickUrl}</button>
                </a>
              </Row>
            </Col>
        </Row>
        <Row>
            <Col sm="6" className="progress-description">
              <span>At least 5 sources are recommended.</span>
            </Col>
        </Row>
        <Row>
            <Col sm="12" className="progress-sources">
                <ChunkProgressBar
                value={this.state.numberOfActiveSources}
                className="chunk-progress"
                style={{ width: '100%' }}
                min={0}
                max={5}
                progressStyle={this.progressStyles}/>
            </Col>
        </Row>
        <br/>
        <Row>
        <Grid data={this.state.sourcesToDisplay}>
          <Column field="source_type" title="Source" editable={false}/>
          <Column field="name" title="Name" editable={false} cell={NameCell}/>
          <Column field="last_week_total" title="# Upcoming" editable={false} className="number-upcoming" width="140%"/>
        </Grid>
      </Row>
      {this.canAddSource() ?
      <Row className="addsources-row">
        <a className="add-sources-button-onboarding" href={`${DashboardMenuOption.content}/addsource`}>
            + Add source</a>
      </Row> : null}
    </div>
    )}

  private canAddSource(): boolean {
    if (this.context.store.getState().config.isDesktop) {
      if (this.context.user.activeCommunity && this.context.user.activeCommunity.billingInfo) {
        const maxAllowed: number =
          getCurrentPlanMaxSources(this.context.user.activeCommunity.billingInfo.currentPlan)
        return maxAllowed > this.state.numberOfActiveSources
      }
    }
    return false
  }

}
